import { Directive, ElementRef, Input } from '@angular/core';
import moment from 'moment';


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FieldValidationDirective
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Directive({ 
    selector: '[field-validation]',
    exportAs:'fieldValidation',
    host: { 
        //'(change)':'onInput($event)',
        '(ngModelChange)':'onModelChange($event)', //Added this because boostrap datepicker was not triggering (input)
        //'(input)':'onInput($event)' //I don't think we need this anymore since we're using ngModelChange now
    }
        
})
export class FieldValidationDirective{

    // INPUTS/OUTPUTS/BINDINGS
    //-------------------------------------------------------------------------------------------------------------------------
    //@HostBinding('style.color') color;
    @Input() required;
    @Input() pattern = "";
    @Input() _minDate = ""; //minDate was conflicting with bootstrap datepicker, so I added the underscore
    @Input() _isDate = false;
    
    isDirty = false;
    isValid = true;
    errors = {
        required:false,
        pattern:false,
        invalidDate:false,
        dateBeforeMin:false
    }
    

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(el:ElementRef) {
        this._el = el;
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){
        this._validate();
    };


    // EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    ////==================================
    //// onChange
    ////==================================
    //onChange(event){
    //    this.MarkAsDirty();
    //    this._validate();
    //};

    //==================================
    // onInput
    //==================================
    onInput(event){
        //console.log("Validation Directive (onInput):", event);
        this.MarkAsDirty();
        this._validate();
    };
    
    //==================================
    // onModelChange
    //==================================
    onModelChange(event){
        //console.log("Validation Directive (onModelChange):", event);
        this.MarkAsDirty();
        this._validate();
    };
    

    // PUBLIC FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // IsDirty
    //==================================
    IsDirty(){
        return this.isDirty;
    }

    //==================================
    // IsValid
    //==================================
    IsValid(){
        return this.isValid;
    }

    //==================================
    // MarkAsClean
    //==================================
    MarkAsClean(){

        //Don't change any values if there is no need.  This will help prevent 
        //infinite Angular 4 check loops down stream.
        if (this.isDirty == false){ return; }

        this.isDirty=false;
        this._el.nativeElement.classList.remove("cpd-dirty");
    };

    //==================================
    // MarkAsDirty
    //==================================
    MarkAsDirty(){

        //Don't change any values if there is no need.  This will help prevent 
        //infinite Angular 4 check loops down stream.
        if (this.isDirty == true){ return; }

        this.isDirty=true;
        this._el.nativeElement.classList.add("cpd-dirty");
    };

    //==================================
    // MarkAsInvalid
    //==================================
    MarkAsInvalid(){
        //Don't change any values if there is no need.  This will help prevent 
        //infinite Angular 4 check loops down stream.
        if (this.isValid == false){ return; }

        this.isValid=false;
        this._el.nativeElement.classList.add("cpd-invalid");
    };

    //==================================
    // MarkAsValid
    //==================================
    MarkAsValid(){
        //Don't change any values if there is no need.  This will help prevent 
        //infinite Angular 4 check loops down stream.
        if (this.isValid == true){ return; }

        this.isValid=true;
        this._el.nativeElement.classList.remove("cpd-invalid");
    };

    //==================================
    // Validate
    //==================================
    Validate(){
        this._validate();
        return this.isValid;
    }

    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _validate
    //==================================
    _validate(){

        //Make sure Angular has time to do its binding before we examine the field (do a timeout 0)
        //setTimeout(()=>{

            //if (this._el.nativeElement.id == "practice_code"){
            //    console.log("");
            //}

            let val = this._el.nativeElement.value;
            let _isValid = true;

            // Check required
            //-----------------------
            if (this.required){

                if (val.trim().length < 1){
                    this.errors.required = true;
                    _isValid = false;
                }
                else{
                    this.errors.required = false;
                }
            }

            // Check pattern
            //-----------------------
            // Determine if a pattern was provided
            if (this.pattern && this.pattern.trim().length > 0){

                //Even if there is a pattern, we only test blank values if the field is required
                if (!this.required && val.trim().length < 1){
                    this.errors.pattern=false;
                }
                else{
                    //We need to test the pattern
                    var re = new RegExp(this.pattern, "g");
                    let match = re.test(val);

                    if (match){
                        this.errors.pattern=false;
                    }
                    else{
                        this.errors.pattern=true;
                        _isValid = false;
                    }
                }
            }

            // Validate as a date?
            //-----------------------
            if (this._isDate && val.trim().length>0){

                let mVal = moment(val, "M/D/YYYY", true);
                if (!mVal.isValid()){
                    _isValid = false;
                    this.errors.invalidDate = true;
                }
            }

            // Check min date
            //-----------------------
            // Determine if a _minDate was provided
            // Only vaidate dates if provided, required validation will ensure dates are provided when required
            if (this._minDate && this._minDate.trim().length > 0 && val.trim().length>0){
                
                //Try to convert _minDate to a date object
                let mMinDate = moment(this._minDate, "M/D/YYYY", true);//strict format
                if (!mMinDate.isValid()){
                    throw("[FieldValidationDirective:_validate] _minDate attribute on fieldValidation element is not valid.  Must be formatted as M/D/YYYY. element:", this._el);
                }

                //Convert the current element value to a date
                let mVal = moment(val, "M/D/YYYY", true); //Switching to strict mode to avoid confusion
                if (mVal.isValid()){

                    this.errors.invalidDate = false; //Clear any outstanding invalidDate flag

                    if (mVal.isBefore(mMinDate)){
                        _isValid = false;
                        this.errors.dateBeforeMin = true;
                    }
                    else{
                        this.errors.dateBeforeMin = false;
                    }
                }
                else{
                    //Val cannot be a valid date, so the field is not valid
                    _isValid = false;
                    this.errors.invalidDate = true;
                }

            }


            //Flag the final results
            if (_isValid){
                this.MarkAsValid();
            }
            else{
                this.MarkAsInvalid();
            }

        //}, 0);

    };
} 
